import React from 'react';
import { NavLink } from 'react-router-dom';

import { Breadcrumb } from 'antd';

interface IProps {
  navList: INavItem[];
  currentPage: string;
}

interface INavItem {
  url: string;
  name: string;
}

function Breadcrumbs({ navList, currentPage }: IProps) {
  const items = [
    ...navList.map((item: INavItem, index: number) => ({
      key: index,
      title: <NavLink to={item.url}>{item.name}</NavLink>
    })),
    { key: 'current', title: currentPage }
  ];

  return (
    <div className='mb-4'>
      <Breadcrumb items={items} />
    </div>
  );
}

export default Breadcrumbs;
